import {combineReducers} from 'redux'
import errorReducer from 'shared/errorHandler/reducer/index'
import flightsReducer from 'screens/flights/reducers/index'
import weatherReducer from 'screens/weather/reducers/index'
import loginReducer from 'screens/login/reducers/index'
import productsReducer from 'screens/briefing/products/reducers/index'
import sigchartsReducer from 'screens/sigcharts/reducers/index'
import flightWeatherReducer from 'screens/briefing/weather/reducers/index'
import briefingReducer from 'screens/briefing/reducers/index'

/* Populated by react-webpack-redux:reducer */
const reducers = {
    error: errorReducer,
    user: loginReducer,
    flights: flightsReducer,
    weather: weatherReducer,
    sigcharts: sigchartsReducer,
    briefing: combineReducers({products: productsReducer, weather: flightWeatherReducer, flightInfo: briefingReducer})
}

export default combineReducers({
    ...reducers
})



// WEBPACK FOOTER //
// ./src/shared/reducers/index.js